import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../../../common/breadcrumbs";
import { SWAL_SETTINGS, PHONE_NO_LENGTH, INPUT_MAX_25, TEXTAREA_MAX_LENGTH, INPUT_LENGTH_15 } from "../../../../../../utils/Constants";
import {
  handleServerValidations,
  DT,
  globalLoader
} from "../../../../../../utils/commonfunction";
import * as Yup from "yup";
import CustomError from "../../../../../../utils/customError";
import { useTranslation } from "react-i18next";
import { DetailsTestimonial, EditTestimonial } from "../../../../services/usermgmt.services";
import { Tooltip, Whisper } from "rsuite";


const CentreTestimonialsEdit = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const { t } = useTranslation();
  const [showdefault, setShowDefault] = useState({});
  const [previewimage, setPreviewImage] = useState("");
  const [saveType, setSaveType] = useState("");
  const location = useLocation();
  const { center_id } = location.state;
  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
    {
      title: t("Center Management"),
      url: "/admin/center-management/center/list/1",
    },
    {
      title: t("Center Testimonials"),
      url: `/admin/center-management/center/testimonial/${center_id}/list/1`,
    },
    { title: t("admin.cafes.link_edit"), url: "" },
  ];

  useEffect(() => {
    DetailsTestimonial(params.id)
      .then((response) => {
        setShowDefault(response && response.data ? response.data : []);
        setPreviewImage(response.data.profile_image);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);


  const validationSchema = Yup.object().shape({
      name: Yup.string().trim().required("Name is required"),
      testimonial_text: Yup.string().required("Testimonial text is required"),
      profile_image: Yup.mixed()
          .nullable()
          .test("fileType", "admin.cafes.supported_file_error", (value) => !value || ["image/jpg", "image/jpeg", "image/png", "image/webp", "image/gif"].includes(value.type))
          .test("fileSize", "admin.cafes.image_max_size_error", (value) => !value || value.size <= 1.5 * 1024 * 1024)
          .test(
              "validImage",
              "Upload a valid image",
              (value) =>
                  new Promise((resolve) => {
                      if (!value || typeof value === "string") return resolve(true);

                      const reader = new FileReader();
                      reader.onload = () => {
                          const img = new Image();
                          img.onload = () => resolve(true);
                          img.onerror = () => resolve(false);
                          img.src = reader.result;
                      };
                      reader.onerror = () => resolve(false);
                      reader.readAsDataURL(value);
                  })
          ),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      center_id: showdefault && showdefault.center_id ? showdefault.center_id : center_id,
      name: showdefault && showdefault.name ? showdefault.name : "",
      testimonial_text: showdefault && showdefault.testimonial_text ? showdefault.testimonial_text : "",
      profile_image: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      globalLoader(true);
      let formData = new FormData();
      formData.append("o_id", params.id);
      formData.append("name", values.name);
      formData.append("center_id", values.center_id);
      formData.append("testimonial_text", values.testimonial_text);
      formData.append("profile_image", values.profile_image);
      EditTestimonial(formData)
        .then((response) => {
          setSubmitting(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
            if (saveType !== "Save") {
              navigate(`/admin/center-management/center/testimonial/${center_id}/list/1`);
            }
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
          globalLoader(false);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(error),
            ...SWAL_SETTINGS,
          });
          console.log("error ====> ", error);
        });
    },
  });
  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <form onSubmit={formik.handleSubmit}>
        <div className="row row-sm">
          <div className="col-lg-12 col-md-12 animation_fade">
            <div className="card custom-card">
              <div className="card-body">
                <div>
                  <h6 className="main-content-label mb-3">
                    {t("Edit Center Testimonial")}
                  </h6>
                </div>
                <div className="row row-sm">

                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="name" className="text-left d-flex">
                      {t("Name")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <input
                      name="name"
                      id="name"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                      className="form-control"
                      placeholder={t("Enter name")}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError shortCodes={[INPUT_LENGTH_15]} name="name" form={formik} />
                    </span>
                    {/* <span>DT(t(form.errror), [])</span> */}
                  </div>

                  <div className="col-lg-6 text-center form-group">
                    <label htmlFor="testimonial_text" className="text-left d-flex">
                      Testimonial Text:<span className="requirestar">*</span>{" "}
                    </label>
                    <textarea
                      name="testimonial_text"
                      id="testimonial_text"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.testimonial_text}
                      className="form-control"
                      placeholder="Enter testimonial text"
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="testimonial_text" form={formik} />
                    </span>
                  </div>

                  <div className="col-lg-6 text-center form-group">
                    <label htmlFor="restaurant_logo" className="text-left d-flex">
                      Profile Image:
                      {" "}
                      <Whisper
                        placement="top"
                        controlId="control-id-hover"
                        trigger="hover"
                        speaker={
                          <Tooltip>
                            {t("admin.cafes.image_support_tooltip")}
                          </Tooltip>
                        }
                      >
                        <span className="field-more-info mt-1 ms-1 cp">
                          ?
                        </span>
                      </Whisper>
                    </label>
                    <input
                      className="form-control imgInput"
                      id="profile_image"
                      name="profile_image"
                      accept="image/*"
                      type="file"
                      onChange={(event) => {
                        formik.setFieldValue(
                          "profile_image",
                          event.target.files[0] || ""
                        );
                        event.target.files.length === 1
                          ? setPreviewImage(
                            URL.createObjectURL(event.target.files[0])
                          )
                          : setPreviewImage("");
                      }}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="profile_image" form={formik} />
                    </span>
                    {previewimage ? (
                      <ul className="question-image-preview questions-ul">
                        <li className="pr_img_box">
                          <img
                            src={previewimage}
                            style={{ height: "100px" }}
                            alt={"profileImg"}
                          />
                        </li>
                      </ul>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="mt-5">
                    <button
                      onClick={() => {
                        setSaveType("Save");
                      }}
                      className="btn btn-info mr-2"
                      type="submit"
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("admin.button.btn_save")}
                    </button>
                    <button
                      onClick={() => {
                        setSaveType("");
                      }}
                      className="btn btn-success mr-2"
                      type="submit"
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("admin.button.btn_save_exit")}
                    </button>
                    <button
                      className="btn ripple btn-secondary"
                      type="button"
                      onClick={() => navigate(-1)}
                    >
                      <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                      {t("admin.button.btn_cancel")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default CentreTestimonialsEdit;